const infoConstants = {
  patientSafetyHubEmail: "support@patientsafetyhub.ie",
  patientSafetyHubPhoneNumber: "+353 58 38 234",
};

export default infoConstants;
